import { NatureCustomData } from '../iCourrier/custom-datas/nature-custom-data';

export class MailsFullParams {
  files?: string[];
  mailUniqueId?: string;
  lien?: {
    linkCourrierId?: number;
    typeLiaison?: string;
  };
  serviceProprietaireId?: number;
  typeEntrantSortant?: string;
  confidentiel?: boolean;
  natureId?: number;
  sourceId?: number;
  refExpediteur?: string;
  expediteurLibre?: string;
  expediteurIdiAdmin?: number;
  expediteurId?: number;
  objet?: string;
  remarques?: string;
  dateDocument?: string;
  dateEcheance?: string;
  dateEntree?: string;
  classementId?: number;
  chemiseId?: number;
  classeurId?: number;
  referenceRecommande?: string;
  datePostale?: string;
  boiteArchive?: string;
  statutId?: number;
  annexeNonScannee?: boolean;
  annexeNonScanneeNombre?: number;
  annexeDiffusee?: boolean;
  centreNumerisationId?: number;
  natureCustomDatas?: NatureCustomData[];
  createMethod?: string;
}
